export default __webpack_public_path__ + "img/rem_brute.be92706f.png";